import { t } from 'services/translation';
import styled from '@emotion/styled';

const Style = styled.h1`
  font-size: 28px;
  font-weight: 600;
  font-style: semibold;
  line-height: 20px;
  margin: 0 0 24px 0;
`;

export const Header = () => {
  return <Style>{t('REVIEW_AND_BOOK')}</Style>;
};
